import script from "./POIModalSimple.vue?vue&type=script&setup=true&lang=js"
export * from "./POIModalSimple.vue?vue&type=script&setup=true&lang=js"

import "./POIModalSimple.vue?vue&type=style&index=0&id=2530528a&lang=css"

const __exports__ = script;

export default __exports__